import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { useDrop } from 'react-dnd';
import { format } from 'date-fns';
import { itemContext } from 'context';

const Container = styled.div`
    /* border: ${props => props.isOver ? '1px solid var(--focus-color)' : '1px solid transparent'}; */
    border-style: ${props => props.styles.borderStyle};
    border-color: ${props => props.styles.borderColor};
    border-width: ${props => props.styles.borderWidth};
    border-radius: ${props => props.styles.borderRadius};
    background-color: ${props => props.styles.backgroundColor};
    background-color: ${props => props.backgroundColor};
    width: 100%;
    height: calc(100% - 1px);
    flex-grow:4;
    position: ${props => props.position};
    /* border-right: 1px solid var(--primary-accent-color); */
    /* min-height: 10rem; */
    box-sizing: border-box;
    /* border: 1px solid red; */
`

const Placeholder = styled.div`
    position: absolute;
    width: ${props => props.width};
    height: ${props => props.height || props.styles.height};

    border-radius: 5px;
    background-color: ${props => props.styles.backgroundColor};
    top: ${props => props.offsetY || '1rem'};
    margin: ${props => props.styles.margin};
    padding: ${props => props.styles.padding};
    z-index: 1;
    box-shadow: var(--box-shadow);
`

const Title = styled.div`
    font-size: 0.8rem;
    color: var(--text-color);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
`

const defaultPreviewStyle = {
    // backgroundColor: itemContext.PRIORITY_COLOR_TWO.NONE,
    backgroundColor: 'var(--primary-accent-color)',
    height: 'auto',
    margin: '0 0 0 0.2rem',
    padding: '0.2rem',
    color: 'var(--text-color)'
}

const Droppable = props => {
    const {
        id,
        accept,
        onHover,
        onDrop,
        hoverStyle,
        disableShallow,
        value,
        styles,
        size,
        previewStyle,
        onSlotDown,
        onSlotHover,
        onSlotOver,
        onSlotUp,
        selected,
        preview
    } = props;
    const ref = useRef(null);
    const [item, setItem] = useState(null)
    const [y, setY] = useState(null)
    const updatedPreviewStyle = Object.assign({}, defaultPreviewStyle, previewStyle)

    const [state, drop] = useDrop({
        accept: accept,
        collect: (monitor) => ({
            isOver: monitor.isOver({ shallow: true }),
        }),
        hover(item, monitor) {
            
            if(monitor.canDrop() & (accept.includes(item.type) | accept === item.type)){
                onHover && onHover(id, item, monitor.getClientOffset())
                setItem(item.props.item)
                let positionY = size && ~~((monitor.getClientOffset()['y'] - ref.current.getBoundingClientRect()['top'])/size)*size
                positionY !== y && setY(positionY)
            }
        },
        drop(item, monitor) {
            if(monitor.canDrop() && onDrop){
                onDrop(id, item, monitor.getClientOffset())
            }
            setItem(null)
        }
    })
    const width = ref.current && `calc(${ref.current.getBoundingClientRect()['width']}px - 0.4rem)`
    let title
    let subtitle
    if(state.isOver){
        title = item && item.getPlainText()
        subtitle = value
        // subtitle = value && format(value, 'LLL d')
    }

    return (
        <Container ref={drop} isOver={state.isOver} position={styles && styles.position} styles={styles} backgroundColor={props.backgroundColor}
            onMouseDown={(e) => onSlotDown && onSlotDown(id,e)} 
            onMouseMove={(e) => onSlotOver && onSlotOver(id,e)} 
            onMouseOver={(e) => onSlotHover && onSlotHover(id,e)} 
            onMouseUp={(e) => onSlotUp && onSlotUp(e)}>
            <div ref={ref} styles={{height: '100%'}}>
                {props.children}

                {/* DND preview */}
                {state.isOver && 
                <Placeholder width={width} offsetY={`${y}px`} styles={updatedPreviewStyle}>
                    <Title>{subtitle}</Title>
                    <Title>{title}</Title>
                </Placeholder>
                }

                {/* [TODO] Slot selection preview */}
                {preview && preview['top'] && 
                <Placeholder width={width} offsetY={preview['top']} height={preview['size']} styles={updatedPreviewStyle}>
                    <Title>{preview['title']}</Title>
                </Placeholder>
                }
            </div>
        </Container>
    )
}

export default Droppable;